import { TrackDef } from '../track.js';

/**
 * SKYFALL — Atmosphere-to-space sprint, expert.
 * One shot, straight up: from sea-level haze through the cloud deck on
 * switchback ramps, over two launch gaps, across a knife-edge ridge with no
 * rails, to a finish gate hanging at the edge of hard vacuum.
 */
export const skyfall: TrackDef = {
  id: 'skyfall',
  name: 'Skyfall',
  tagline: 'Sea level to the edge of space in one screaming climb. Do not look down.',
  environment: 'ascent',
  difficulty: 4,
  layout: 'sprint',
  defaultLaps: 1,
  width: 24,
  unlockLevel: 10,
  points: [
    { x: 0, y: 22, z: -240 }, // tangent handle
    { x: 0, y: 20, z: 0, width: 30 },
    { x: 0, y: 20, z: 260, width: 30 },
    { x: 40, y: 26, z: 520, width: 28 },
    { x: 160, y: 44, z: 740, width: 26, roll: -0.25 },
    { x: 400, y: 66, z: 840, width: 26, roll: -0.3 },
    { x: 640, y: 90, z: 760, width: 26, roll: -0.28 },
    { x: 760, y: 115, z: 560, width: 24, roll: -0.22 },
    { x: 780, y: 145, z: 320, width: 24 },
    { x: 720, y: 175, z: 100, width: 24, roll: -0.3 },
    { x: 520, y: 208, z: -20, width: 24, roll: -0.3 },
    { x: 280, y: 196, z: -40, width: 26 },
    { x: 60, y: 240, z: 20, width: 24, roll: -0.3 },
    { x: -60, y: 270, z: 220, width: 22, roll: -0.28 },
    { x: -40, y: 300, z: 460, width: 22 },
    { x: 40, y: 290, z: 680, width: 22, roll: -0.25 },
    { x: 240, y: 345, z: 780, width: 22, roll: -0.3 },
    { x: 460, y: 370, z: 720, width: 20, roll: -0.28 },
    { x: 580, y: 395, z: 520, width: 20 },
    { x: 600, y: 420, z: 280, width: 20 },
    { x: 560, y: 438, z: 40, width: 22, roll: -0.2 },
    { x: 450, y: 452, z: -170, width: 24 },
    { x: 320, y: 460, z: -340, width: 26 },
    { x: 200, y: 464, z: -500, width: 28 },
    { x: 90, y: 466, z: -650 }, // tangent handle
  ],
  features: [
    { kind: 'boost', s: 0.02, length: 0.007, lane: 0 },
    { kind: 'boost', s: 0.08, length: 0.007, lane: -0.3 },
    { kind: 'zone', s: 0.18, length: 0.14, name: 'cloudsea' },
    { kind: 'boost', s: 0.33, length: 0.007, lane: 0.3 },
    { kind: 'jump', s: 0.448, length: 0.006 },
    { kind: 'boost', s: 0.55, length: 0.007, lane: 0 },
    { kind: 'jump', s: 0.625, length: 0.006 },
    { kind: 'noWalls', s: 0.785, length: 0.05, side: 'both' },
    { kind: 'zone', s: 0.75, length: 0.12, name: 'thermosphere' },
    { kind: 'boost', s: 0.85, length: 0.007, lane: 0 },
  ],
  medals: { bronze: 66.7, silver: 57.5, gold: 51.3, author: 47.7 },
};
